import { render, staticRenderFns } from "./XrayModal.vue?vue&type=template&id=2da927ec&"
import script from "./XrayModal.vue?vue&type=script&lang=js&"
export * from "./XrayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports